import { EventBus } from '@/utils/EventBus';

export interface MetaError {
  code: number;
  message: string;
  stack: string;
}

export const metaMaskErrorHandler = (error: MetaError) => {
  if (error.code === 4001) {
    EventBus.$emit('trx-result', { status: 'cancel', trxId: '' });
  } else {
    console.log(error);
  }
};
